import requests from "./httpService";

const NotificationService = {
  getCompanyNotifications(id, includeRead = false) {
    return requests.get(`/notification/all?company_id=${id}${includeRead ? '&include_read=true' : ''}`);
  },
  // the user's channel invitations (read or not, any age): the chat lists the channels waiting to be accepted
  getChatInvites(id) {
    return requests.get(`/notification/all?company_id=${id}&chat_invites=true`);
  },
  markAllRead(id,body) {
    return requests.get(`/notification/readAll?company_id=${id}`, body);
  },
  readNotification(id,compid,body) {
    return requests.post(`/notification/readOne/${id}`, body);
  },
};

export default NotificationService;
